// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
/* eslint-disable @typescript-eslint/no-explicit-any */
import type {
  ComponentType,
  ReactElement,
  ReactNode,
  Ref,
} from 'react';

import MaskedInput from 'react-text-mask';
import type {
  Mask,
} from 'react-text-mask';

import { Input } from '../Input';
import type {
  InputProps,
} from '../Input';

export type InputMaskProps<
InputComponent extends ComponentType<any> | keyof JSX.IntrinsicElements,
> = InputProps<InputComponent> & {
  /**
   * маска в формате react-text-mask
   */
  mask: Mask | ((value: string) => Mask);
};

export function InputMask<
InputComponent extends ComponentType<any> | keyof JSX.IntrinsicElements = 'input',
>({
  mask,
  onChange = undefined,
  value,
  component,
  ...rest
}: InputMaskProps<InputComponent>): ReactElement {
  return (
    <MaskedInput
      mask={mask}
      onChange={onChange}
      value={value}
      render={(
        ref,
        {
          defaultValue,
          ...renderProps
        },
      ): ReactNode => (
        <Input
          ref={ref as Ref<HTMLInputElement>}
          // typescript fix
          component={component as undefined}
          {...rest}
          value={typeof value === 'string' ? value : ''}
          {...renderProps}
        />
      )}
    />
  );
}
